// @Path: packages/types/device/lite/cf_lel.ts
// @Author: SWAN
// @Created: 2025-07-08
// @Description: SensorType별 Correction Factor (lel_CF_Index) 정의.

import type { Option } from '../../common/option';

// 1Series 75C LEL 센서 Correction Factor (10~255는 Reserved, 9는 Custom)
export enum CF_1SeriesType {
  METHANE = 0,
  PROPANE = 1,
  I_BUTANE = 2,
  N_BUTANE = 3,
  PENTANE = 4,
  HYDROGEN = 5,
  HEXANE = 6,
  ETHANE = 7,
  BUTADIENE_1_3 = 8,
  CUSTOM = 9,
  RESERVED = 255,
}

enum CF_IRType {
  METHANE = 0,
  RESERVED = 255,
}

// SGX LEL 센서 Correction Factor (8~255는 Reserved, 7은 Custom)
export enum CF_LPCType {
  METHANE = 0,
  PROPANE = 1,
  I_BUTANE = 2,
  N_BUTANE = 3,
  PENTANE = 4,
  HYDROGEN = 5,
  ACETYLENE = 6,
  CUSTOM = 7,
  RESERVED = 255,
}

export type CF_option = Option<number>;

// SensorType enum이 먼저 정의되어 있어야 함
import { SensorType } from './sensors';

export const SENSOR_TO_CF_OPTIONS: Record<SensorType, CF_option[]> = {
  [SensorType.LEL_LPC]: [
    { value: CF_LPCType.METHANE, label: 'Methane(1.00)' },
    { value: CF_LPCType.PROPANE, label: 'Propane(1.70)' },
    { value: CF_LPCType.I_BUTANE, label: 'i-Butane(1.76)' },
    { value: CF_LPCType.N_BUTANE, label: 'n-Butane(1.61)' },
    { value: CF_LPCType.PENTANE, label: 'Pentane(1.23)' },
    { value: CF_LPCType.HYDROGEN, label: 'Hydrogen(0.66)' },
    { value: CF_LPCType.ACETYLENE, label: 'Acetylene(1.50)' },
    { value: CF_LPCType.CUSTOM, label: 'Custom' },
  ],
  [SensorType.LEL_1Series]: [
    { value: CF_1SeriesType.METHANE, label: 'Methane(1.00)' },
    { value: CF_1SeriesType.PROPANE, label: 'Propane(1.60)' },
    { value: CF_1SeriesType.I_BUTANE, label: 'i-Butane(1.80)' },
    { value: CF_1SeriesType.N_BUTANE, label: 'n-Butane(1.78)' },
    { value: CF_1SeriesType.PENTANE, label: 'Pentane(2.09)' },
    { value: CF_1SeriesType.HYDROGEN, label: 'Hydrogen(1.54)' },
    { value: CF_1SeriesType.HEXANE, label: 'Hexane(2.03)' },
    { value: CF_1SeriesType.ETHANE, label: 'Ethane(1.39)' },
    { value: CF_1SeriesType.BUTADIENE_1_3, label: '1,3-Butadiene(2.12)' },
    { value: CF_1SeriesType.CUSTOM, label: 'Custom' },
  ],
  [SensorType.CO]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.CO_ALPHA]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.H2S_ALPHA]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.O2]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.O2LF]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.H2S]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.CO2_CRANBERRY]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.CO2_CRANBERRY_VOL]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
  [SensorType.LEL_IR]: [{ value: CF_IRType.METHANE, label: 'Methane(1.0)' }],
  [SensorType.NO_SENSOR]: [{ value: CF_IRType.RESERVED, label: 'RESERVED' }],
};
